export default __webpack_public_path__ + "static/media/aurora.f137c6de.png";